import { render, staticRenderFns } from "./PgSubscription.vue?vue&type=template&id=60362744&scoped=true&"
import script from "./PgSubscription.vue?vue&type=script&lang=js&"
export * from "./PgSubscription.vue?vue&type=script&lang=js&"
import style0 from "./PgSubscription.vue?vue&type=style&index=0&id=60362744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60362744",
  null
  
)

export default component.exports